export var ILoginAccountTypes;
(function (ILoginAccountTypes) {
    ILoginAccountTypes["EQ"] = "EQ";
    ILoginAccountTypes["CO"] = "CO";
    ILoginAccountTypes["COMEQ"] = "COMEQ";
})(ILoginAccountTypes || (ILoginAccountTypes = {}));
export var ILoginFlows;
(function (ILoginFlows) {
    ILoginFlows["GUEST"] = "GUEST";
    ILoginFlows["CLIENT"] = "CLIENT";
})(ILoginFlows || (ILoginFlows = {}));
export var LoginRequestMode;
(function (LoginRequestMode) {
    LoginRequestMode["CELL"] = "CELL";
    LoginRequestMode["EMAIL"] = "EMAIL";
    LoginRequestMode["BOTH"] = "BOTH";
})(LoginRequestMode || (LoginRequestMode = {}));
